/**
 * Funkcinės Terapijos Centras — Traumos tipo nustatymas
 * Self-injecting widget. Embed with:
 *
 *   Place <div id="ftc-injury-checker"></div> in your blog post HTML.
 *   Load via Liquid: {{ 'ftc-injury.js' | asset_url | script_tag }}
 */
(function () {
  'use strict';

  var scriptTag = document.currentScript;
  var KLAVIYO_COMPANY_ID = scriptTag.getAttribute('data-klaviyo-id') || 'WGyTS6';
  var KLAVIYO_LIST_ID = scriptTag.getAttribute('data-list-id') || 'QU9WVJ';
  var BOOKING_URL = scriptTag.getAttribute('data-booking-url') || 'https://funkcinesterapijoscentras.lt/pages/registracija';

  // ── Inject CSS ──
  var css = document.createElement('style');
  css.textContent = '' +
    '.ftci *,.ftci *::before,.ftci *::after{box-sizing:border-box;margin:0;padding:0}' +
    '.ftci{font-family:"Segoe UI",system-ui,-apple-system,sans-serif;max-width:640px;margin:40px auto;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(30,126,186,.18);background:#fff}' +
    '.ftci-header{background:linear-gradient(135deg,#1E7EBA 0%,#1a6da3 100%);padding:32px 28px 24px;text-align:center;position:relative;overflow:hidden}' +
    '.ftci-header::before{content:"";position:absolute;top:-40%;right:-20%;width:260px;height:260px;background:rgba(0,190,195,.12);border-radius:50%}' +
    '.ftci-header::after{content:"";position:absolute;bottom:-30%;left:-10%;width:180px;height:180px;background:rgba(255,255,255,.06);border-radius:50%}' +
    '.ftci-header h2{color:#fff;font-size:22px;font-weight:700;margin-bottom:6px;position:relative;z-index:1;line-height:1.3}' +
    '.ftci-header p{color:rgba(255,255,255,.85);font-size:14px;position:relative;z-index:1}' +
    '.ftci-badge{display:inline-block;background:rgba(0,190,195,.25);color:#fff;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:1.2px;padding:4px 14px;border-radius:20px;margin-bottom:12px;position:relative;z-index:1}' +
    '.ftci-progress-wrap{padding:0 28px;margin-top:-8px;position:relative;z-index:2}' +
    '.ftci-progress-bar{height:6px;background:#e8f0f5;border-radius:3px;overflow:hidden;margin-top:16px}' +
    '.ftci-progress-fill{height:100%;background:linear-gradient(90deg,#00BEC3,#1E7EBA);border-radius:3px;transition:width .5s cubic-bezier(.4,0,.2,1);width:0%}' +
    '.ftci-step-count{text-align:center;font-size:12px;color:#7a9bb5;margin-top:8px;font-weight:500}' +
    '.ftci-body{padding:24px 28px 28px;min-height:320px;position:relative}' +
    '.ftci-intro{text-align:center}' +
    '.ftci-intro-icon{width:72px;height:72px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 20px}' +
    '.ftci-intro-icon svg{width:36px;height:36px;color:#1E7EBA}' +
    '.ftci-intro h3{font-size:18px;color:#1a2e3d;margin-bottom:10px;font-weight:600}' +
    '.ftci-intro p{font-size:14px;color:#5a7080;line-height:1.6;margin-bottom:8px}' +
    '.ftci-intro-list{text-align:left;margin:16px auto;max-width:380px}' +
    '.ftci-intro-list-item{display:flex;align-items:flex-start;gap:10px;padding:8px 0;font-size:13px;color:#3d5a6e}' +
    '.ftci-intro-list-item .ftci-check{width:20px;height:20px;min-width:20px;background:#00BEC3;border-radius:50%;display:flex;align-items:center;justify-content:center;margin-top:1px}' +
    '.ftci-intro-list-item .ftci-check svg{width:12px;height:12px;color:#fff}' +
    '.ftci-slide{display:none;animation:ftciFadeIn .4s ease}' +
    '.ftci-slide.active{display:block}' +
    '@keyframes ftciFadeIn{from{opacity:0;transform:translateY(12px)}to{opacity:1;transform:translateY(0)}}' +
    '.ftci-question-num{font-size:12px;font-weight:600;color:#00BEC3;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px}' +
    '.ftci-question-text{font-size:17px;color:#1a2e3d;font-weight:600;margin-bottom:6px;line-height:1.4}' +
    '.ftci-question-hint{font-size:13px;color:#7a9bb5;margin-bottom:24px;line-height:1.5}' +
    '.ftci-options{display:flex;flex-direction:column;gap:10px;margin-top:4px}' +
    '.ftci-option{display:flex;align-items:center;gap:12px;padding:14px 16px;border:2px solid #e8f0f5;border-radius:12px;cursor:pointer;transition:all .25s ease;background:#fff}' +
    '.ftci-option:hover{border-color:#b8dce8;background:#f6fbfd}' +
    '.ftci-option.selected{border-color:#00BEC3;background:#e6f9fa}' +
    '.ftci-option-radio{width:22px;height:22px;min-width:22px;border-radius:50%;border:2px solid #c8d8e2;display:flex;align-items:center;justify-content:center;transition:all .25s ease}' +
    '.ftci-option.selected .ftci-option-radio{border-color:#00BEC3;background:#00BEC3}' +
    '.ftci-option.selected .ftci-option-radio::after{content:"";width:8px;height:8px;background:#fff;border-radius:50%}' +
    '.ftci-option-text{font-size:14px;color:#2a4050;font-weight:500}' +
    '.ftci-area-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-top:4px}' +
    '.ftci-area{display:flex;flex-direction:column;align-items:center;gap:8px;padding:20px 12px;border:2px solid #e8f0f5;border-radius:14px;cursor:pointer;transition:all .25s ease;background:#fff;text-align:center}' +
    '.ftci-area:hover{border-color:#b8dce8;background:#f6fbfd}' +
    '.ftci-area.selected{border-color:#00BEC3;background:#e6f9fa}' +
    '.ftci-area-icon{width:48px;height:48px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center}' +
    '.ftci-area.selected .ftci-area-icon{background:linear-gradient(135deg,#00BEC3,#00a8ad)}' +
    '.ftci-area-icon svg{width:24px;height:24px;color:#1E7EBA}' +
    '.ftci-area.selected .ftci-area-icon svg{color:#fff}' +
    '.ftci-area-name{font-size:14px;font-weight:600;color:#2a4050}' +
    '.ftci-slider-wrap{padding:12px 0 8px}' +
    '.ftci-slider-labels{display:flex;justify-content:space-between;margin-bottom:12px}' +
    '.ftci-slider-label{font-size:12px;font-weight:500;padding:6px 12px;border-radius:8px;transition:all .3s ease;max-width:45%;text-align:center;line-height:1.3}' +
    '.ftci-slider-label.left{color:#27ae60;background:#e8f8ef}' +
    '.ftci-slider-label.right{color:#c0392b;background:#fce8e6}' +
    '.ftci-range-track{position:relative;height:48px;display:flex;align-items:center}' +
    '.ftci-range{-webkit-appearance:none;appearance:none;width:100%;height:8px;border-radius:4px;background:linear-gradient(90deg,#27ae60,#e0e8ed 50%,#e05555);outline:none;cursor:pointer}' +
    '.ftci-range::-webkit-slider-thumb{-webkit-appearance:none;appearance:none;width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer;transition:transform .2s ease,box-shadow .2s ease}' +
    '.ftci-range::-webkit-slider-thumb:hover{transform:scale(1.15);box-shadow:0 3px 14px rgba(0,190,195,.4)}' +
    '.ftci-range::-moz-range-thumb{width:28px;height:28px;border-radius:50%;background:#fff;border:3px solid #00BEC3;box-shadow:0 2px 8px rgba(0,190,195,.3);cursor:pointer}' +
    '.ftci-range-value{text-align:center;margin-top:8px;font-size:13px;font-weight:600;color:#1E7EBA;min-height:20px}' +
    '.ftci-buttons{display:flex;justify-content:space-between;align-items:center;margin-top:28px;gap:12px}' +
    '.ftci-btn{padding:12px 28px;border-radius:10px;font-size:14px;font-weight:600;cursor:pointer;border:none;transition:all .3s ease;display:inline-flex;align-items:center;gap:6px}' +
    '.ftci-btn-primary{background:linear-gradient(135deg,#00BEC3,#00a8ad);color:#fff;box-shadow:0 4px 14px rgba(0,190,195,.3)}' +
    '.ftci-btn-primary:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftci-btn-secondary{background:transparent;color:#7a9bb5;border:2px solid #e0e8ed}' +
    '.ftci-btn-secondary:hover{border-color:#b8d0dd;color:#5a7a90}' +
    '.ftci-btn-large{width:100%;justify-content:center;padding:14px 28px;font-size:15px}' +
    '.ftci-btn svg{width:16px;height:16px}' +
    '.ftci-email-gate{text-align:center}' +
    '.ftci-email-gate h3{font-size:18px;color:#1a2e3d;margin-bottom:8px;font-weight:600}' +
    '.ftci-email-gate p{font-size:14px;color:#5a7080;margin-bottom:20px;line-height:1.5}' +
    '.ftci-email-icon{width:64px;height:64px;background:linear-gradient(135deg,#e6f5f6,#d4eef5);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 16px}' +
    '.ftci-email-icon svg{width:30px;height:30px;color:#1E7EBA}' +
    '.ftci-input-wrap{position:relative;margin-bottom:12px}' +
    '.ftci-input{width:100%;padding:14px 16px;border:2px solid #e0e8ed;border-radius:10px;font-size:14px;font-family:inherit;color:#2a4050;outline:none;transition:border-color .3s ease;background:#fff}' +
    '.ftci-input:focus{border-color:#00BEC3}' +
    '.ftci-input::placeholder{color:#a8bcc8}' +
    '.ftci-email-note{font-size:11px;color:#a0b0bb;margin-top:8px}' +
    '.ftci-email-error{color:#e05555;font-size:12px;margin-top:4px;display:none}' +
    '.ftci-results{text-align:center}' +
    '.ftci-result-circle-wrap{position:relative;width:160px;height:160px;margin:0 auto 20px}' +
    '.ftci-result-circle{width:160px;height:160px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;position:relative;z-index:1}' +
    '.ftci-result-circle.tendon{background:linear-gradient(135deg,#fff4e6,#ffe8cc);border:3px solid #e8a04c}' +
    '.ftci-result-circle.ligament{background:linear-gradient(135deg,#e6f5fa,#ccebf5);border:3px solid #1E7EBA}' +
    '.ftci-result-circle.bursa{background:linear-gradient(135deg,#e8f8ef,#d0f0db);border:3px solid #27ae60}' +
    '.ftci-result-circle.meniscus{background:linear-gradient(135deg,#f3e8fa,#e6d0f5);border:3px solid #8e44ad}' +
    '.ftci-result-type{font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:1px;margin-bottom:2px}' +
    '.ftci-result-label{font-size:17px;font-weight:700;text-align:center;line-height:1.2;padding:0 8px}' +
    '.ftci-result-circle.tendon .ftci-result-type{color:#c46b20}.ftci-result-circle.tendon .ftci-result-label{color:#a35a18}' +
    '.ftci-result-circle.ligament .ftci-result-type{color:#1E7EBA}.ftci-result-circle.ligament .ftci-result-label{color:#165f8a}' +
    '.ftci-result-circle.bursa .ftci-result-type{color:#1e8449}.ftci-result-circle.bursa .ftci-result-label{color:#1a7a40}' +
    '.ftci-result-circle.meniscus .ftci-result-type{color:#8e44ad}.ftci-result-circle.meniscus .ftci-result-label{color:#6c3483}' +
    '.ftci-result-text{font-size:15px;color:#2a4050;line-height:1.6;margin-bottom:16px;max-width:480px;margin-left:auto;margin-right:auto}' +
    '.ftci-result-detail{background:#f6f9fb;border-radius:12px;padding:16px 20px;margin-bottom:20px;text-align:left}' +
    '.ftci-result-detail h4{font-size:14px;font-weight:600;color:#1a2e3d;margin-bottom:8px}' +
    '.ftci-result-detail p{font-size:13px;color:#5a7080;line-height:1.5}' +
    '.ftci-result-cta,.ftci-result-cta:visited,.ftci-result-cta:active,.ftci-result-cta:hover{background:#00BEC3;color:#fff !important;padding:14px 32px;border-radius:10px;font-size:15px;font-weight:600;cursor:pointer;border:none;display:inline-flex;align-items:center;gap:8px;transition:all .3s ease;box-shadow:0 4px 14px rgba(0,190,195,.3);text-decoration:none !important}' +
    '.ftci-result-cta:hover{transform:translateY(-1px);box-shadow:0 6px 20px rgba(0,190,195,.4)}' +
    '.ftci-result-cta svg{width:18px;height:18px}' +
    '.ftci-disclaimer{font-size:11px;color:#a0b0bb;margin-top:16px;line-height:1.4;padding-top:12px;border-top:1px solid #eef2f5}' +
    '@media(max-width:480px){.ftci{margin:16px 8px;border-radius:12px}.ftci-header{padding:24px 20px 18px}.ftci-header h2{font-size:19px}.ftci-body{padding:20px 20px 24px}.ftci-progress-wrap{padding:0 20px}.ftci-area-grid{grid-template-columns:1fr 1fr}.ftci-slider-label{font-size:11px;padding:4px 8px}.ftci-buttons{flex-direction:column-reverse}.ftci-btn{width:100%;justify-content:center}}';
  document.head.appendChild(css);

  // ── SVG helpers ──
  var svgArrowRight = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6"/></svg>';
  var svgArrowLeft  = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M11 17l-5-5m0 0l5-5m-5 5h12"/></svg>';
  var svgCheck      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"/></svg>';
  var svgCheckSmall = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="3"><path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/></svg>';
  var svgMail       = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>';
  var svgCalendar   = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>';
  // Body area icons
  var svgShoulder = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><circle cx="12" cy="5" r="2"/><path stroke-linecap="round" stroke-linejoin="round" d="M4 17l4-4 4 4 4-4 4 4M8 13V9c0-1 1-2 4-2s4 1 4 2v4"/></svg>';
  var svgKnee     = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M12 2v7m0 0c-2 0-3 1.5-3 3s1 3 3 3 3-1.5 3-3-1-3-3-3zm0 6v9"/></svg>';
  var svgElbow    = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M7 4v8c0 2 1 3 3 4l4 2M17 4v6c0 2-1 4-3 5"/></svg>';
  var svgHip      = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><circle cx="12" cy="10" r="4"/><path stroke-linecap="round" stroke-linejoin="round" d="M8 14l-3 7m11-7l3 7M12 6V3"/></svg>';
  var svgBody     = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"><path stroke-linecap="round" stroke-linejoin="round" d="M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2m4-2a2 2 0 110 4 2 2 0 010-4z"/></svg>';

  // ── Build HTML ──
  var html = '' +
    '<div class="ftci-header">' +
      '<div class="ftci-badge">Nemokamas testas</div>' +
      '<h2>Kokią traumą patyrėte?</h2>' +
      '<p>Traumos tipo nustatymo testas</p>' +
    '</div>' +
    '<div class="ftci-progress-wrap" id="ftciProgressWrap" style="display:none;">' +
      '<div class="ftci-progress-bar"><div class="ftci-progress-fill" id="ftciProgressFill"></div></div>' +
      '<div class="ftci-step-count" id="ftciStepCount"></div>' +
    '</div>' +
    '<div class="ftci-body">' +

      // Intro
      '<div class="ftci-slide active" id="ftciIntro"><div class="ftci-intro">' +
        '<div class="ftci-intro-icon">' + svgBody + '</div>' +
        '<h3>Sužinokite savo traumos tipą</h3>' +
        '<p>Pasirinkite skausmo vietą ir atsakykite į 5 klausimus — sužinokite, ar tai sausgyslės, raiščio, bursito ar menisko problema.</p>' +
        '<div class="ftci-intro-list">' +
          '<div class="ftci-intro-list-item"><div class="ftci-check">' + svgCheckSmall + '</div><span>Užtrunka tik 2 minutes</span></div>' +
          '<div class="ftci-intro-list-item"><div class="ftci-check">' + svgCheckSmall + '</div><span>Pritaikytas jūsų skausmo vietai</span></div>' +
          '<div class="ftci-intro-list-item"><div class="ftci-check">' + svgCheckSmall + '</div><span>Gausite traumos tipo įvertinimą</span></div>' +
        '</div>' +
        '<button class="ftci-btn ftci-btn-primary ftci-btn-large" id="ftciStartBtn">Pradėti testą ' + svgArrowRight + '</button>' +
      '</div></div>' +

      // Q1 — Body area selector
      '<div class="ftci-slide" id="ftciQ1">' +
        '<div class="ftci-question-num">1 klausimas iš 5</div>' +
        '<div class="ftci-question-text">Kur jaučiate skausmą?</div>' +
        '<div class="ftci-question-hint">Pasirinkite sritį, kurioje skausmas stipriausias.</div>' +
        '<div class="ftci-area-grid" id="ftciAreaGrid">' +
          '<div class="ftci-area" data-area="shoulder"><div class="ftci-area-icon">' + svgShoulder + '</div><div class="ftci-area-name">Petys</div></div>' +
          '<div class="ftci-area" data-area="knee"><div class="ftci-area-icon">' + svgKnee + '</div><div class="ftci-area-name">Kelis</div></div>' +
          '<div class="ftci-area" data-area="elbow"><div class="ftci-area-icon">' + svgElbow + '</div><div class="ftci-area-name">Alkūnė</div></div>' +
          '<div class="ftci-area" data-area="hip"><div class="ftci-area-icon">' + svgHip + '</div><div class="ftci-area-name">Klubas</div></div>' +
        '</div>' +
      '</div>' +

      // Q2 — How did it happen
      '<div class="ftci-slide" id="ftciQ2">' +
        '<div class="ftci-question-num">2 klausimas iš 5</div>' +
        '<div class="ftci-question-text">Kaip atsirado skausmas?</div>' +
        '<div class="ftci-question-hint">Traumos kilmė padeda nustatyti pažeidimo tipą.</div>' +
        '<div class="ftci-options" id="ftciO2">' +
          '<div class="ftci-option" data-t="30" data-l="5" data-b="10" data-m="5"><div class="ftci-option-radio"></div><div class="ftci-option-text">Palaipsniui, nuo pasikartojančių judesių ar perkrovos</div></div>' +
          '<div class="ftci-option" data-t="5" data-l="35" data-b="5" data-m="30"><div class="ftci-option-radio"></div><div class="ftci-option-text">Staigiai, dėl trauma ar netikėto judesio</div></div>' +
          '<div class="ftci-option" data-t="10" data-l="10" data-b="30" data-m="5"><div class="ftci-option-radio"></div><div class="ftci-option-text">Atsirado be aiškios priežasties, tiesiog pradėjo skaudėti</div></div>' +
          '<div class="ftci-option" data-t="15" data-l="15" data-b="10" data-m="25"><div class="ftci-option-radio"></div><div class="ftci-option-text">Po sporto ar fizinio krūvio, pajutau girgždesį ar spragtelėjimą</div></div>' +
        '</div>' +
      '</div>' +

      // Q3 — Pain character
      '<div class="ftci-slide" id="ftciQ3">' +
        '<div class="ftci-question-num">3 klausimas iš 5</div>' +
        '<div class="ftci-question-text">Kokio pobūdžio skausmą jaučiate?</div>' +
        '<div class="ftci-question-hint">Skausmo pobūdis padeda atskirti audinio tipą.</div>' +
        '<div class="ftci-options" id="ftciO3">' +
          '<div class="ftci-option" data-t="35" data-l="10" data-b="5" data-m="5"><div class="ftci-option-radio"></div><div class="ftci-option-text">Deginantis ar aštriai maudžiantis prie sąnario</div></div>' +
          '<div class="ftci-option" data-t="5" data-l="30" data-b="5" data-m="15"><div class="ftci-option-radio"></div><div class="ftci-option-text">Nestabilumo jausmas, sąnarys \u201Eišslysta\u201C</div></div>' +
          '<div class="ftci-option" data-t="5" data-l="5" data-b="35" data-m="5"><div class="ftci-option-radio"></div><div class="ftci-option-text">Šiluma, patinimas ir skausmas paspaudus</div></div>' +
          '<div class="ftci-option" data-t="5" data-l="10" data-b="5" data-m="30"><div class="ftci-option-radio"></div><div class="ftci-option-text">Užsirakina arba blokuojasi judesys, girdisi spragtelėjimas</div></div>' +
        '</div>' +
      '</div>' +

      // Q4 — Swelling/stiffness
      '<div class="ftci-slide" id="ftciQ4">' +
        '<div class="ftci-question-num">4 klausimas iš 5</div>' +
        '<div class="ftci-question-text">Ar yra patinimas arba sustingimas?</div>' +
        '<div class="ftci-question-hint">Patinimo pobūdis ir vieta padeda nustatyti traumos tipą.</div>' +
        '<div class="ftci-options" id="ftciO4">' +
          '<div class="ftci-option" data-t="20" data-l="10" data-b="5" data-m="10"><div class="ftci-option-radio"></div><div class="ftci-option-text">Nėra patinimo, tik skausmas judant</div></div>' +
          '<div class="ftci-option" data-t="5" data-l="25" data-b="10" data-m="25"><div class="ftci-option-radio"></div><div class="ftci-option-text">Bendras sąnario patinimas</div></div>' +
          '<div class="ftci-option" data-t="10" data-l="5" data-b="30" data-m="5"><div class="ftci-option-radio"></div><div class="ftci-option-text">Lokalizuotas patinimas vienoje vietoje, minkštas paspaudus</div></div>' +
          '<div class="ftci-option" data-t="15" data-l="10" data-b="5" data-m="15"><div class="ftci-option-radio"></div><div class="ftci-option-text">Ryto sustingimas, kuris praeina pajudėjus</div></div>' +
        '</div>' +
      '</div>' +

      // Q5 — Severity slider
      '<div class="ftci-slide" id="ftciQ5">' +
        '<div class="ftci-question-num">5 klausimas iš 5</div>' +
        '<div class="ftci-question-text">Kiek skausmas riboja jūsų kasdienę veiklą?</div>' +
        '<div class="ftci-question-hint">Ar galite normaliai judėti, dirbti, sportuoti?</div>' +
        '<div class="ftci-slider-wrap"><div class="ftci-slider-labels"><span class="ftci-slider-label left">Minimaliai trukdo</span><span class="ftci-slider-label right">Visiškai riboja</span></div>' +
        '<div class="ftci-range-track"><input type="range" class="ftci-range" id="ftciR5" min="0" max="100" value="50"></div>' +
        '<div class="ftci-range-value" id="ftciV5"></div></div>' +
      '</div>' +

      // Email gate
      '<div class="ftci-slide" id="ftciEmail"><div class="ftci-email-gate">' +
        '<div class="ftci-email-icon">' + svgMail + '</div>' +
        '<h3>Jūsų diagnozė paruošta!</h3>' +
        '<p>Įveskite savo el. paštą ir gaukite detalią analizę bei reabilitacijos rekomendacijas.</p>' +
        '<div class="ftci-input-wrap"><input type="email" class="ftci-input" id="ftciEmailInput" placeholder="jūsų@elpaštas.lt"><div class="ftci-email-error" id="ftciEmailError">Įveskite teisingą el. pašto adresą</div></div>' +
        '<button class="ftci-btn ftci-btn-primary ftci-btn-large" id="ftciEmailBtn">Gauti rezultatus ' + svgCheck + '</button>' +
        '<div class="ftci-email-note">Galėsite bet kada atsisakyti naujienlaiškio.</div>' +
      '</div></div>' +

      // Results
      '<div class="ftci-slide" id="ftciResults"><div class="ftci-results">' +
        '<div class="ftci-result-circle-wrap"><div class="ftci-result-circle" id="ftciResultCircle"><div class="ftci-result-type" id="ftciResultType"></div><div class="ftci-result-label" id="ftciResultLabel"></div></div></div>' +
        '<div class="ftci-result-text" id="ftciResultText"></div>' +
        '<div class="ftci-result-detail" id="ftciResultDetail"><h4 id="ftciDetailTitle"></h4><p id="ftciDetailText"></p></div>' +
        '<a class="ftci-result-cta" href="' + BOOKING_URL + '" target="_blank">Registruotis konsultacijai ' + svgCalendar + '</a>' +
        '<div class="ftci-disclaimer">Šis klausimynas yra informacinio pobūdžio ir nepakeičia profesionalaus gydytojo ar kineziterapeuto konsultacijos.</div>' +
      '</div></div>' +

      // Nav
      '<div class="ftci-buttons" id="ftciNav" style="display:none;">' +
        '<button class="ftci-btn ftci-btn-secondary" id="ftciBtnBack">' + svgArrowLeft + ' Atgal</button>' +
        '<button class="ftci-btn ftci-btn-primary" id="ftciBtnNext">Kitas ' + svgArrowRight + '</button>' +
      '</div>' +

    '</div>';

  // ── Mount ──
  var target = document.getElementById('ftc-injury-checker');
  if (!target) return;
  var root = document.createElement('div');
  root.className = 'ftci';
  root.id = 'ftciChecker';
  root.innerHTML = html;
  target.appendChild(root);

  // ── State ──
  var currentStep = 0;
  var totalSteps = 5;
  var selectedArea = null;
  var scores = { t: 0, l: 0, b: 0, m: 0 }; // tendon, ligament, bursa, meniscus
  var selectedOpts = {};
  var severityVal = 50;

  var nav          = document.getElementById('ftciNav');
  var progressWrap = document.getElementById('ftciProgressWrap');
  var backBtn      = document.getElementById('ftciBtnBack');
  var nextBtn      = document.getElementById('ftciBtnNext');
  var progressFill = document.getElementById('ftciProgressFill');
  var stepCount    = document.getElementById('ftciStepCount');

  // ── Helper: remove area bonus for previous selection ──
  function removeAreaBonus(area) {
    if (area === 'knee') { scores.m -= 15; scores.l -= 10; }
    else if (area === 'shoulder') { scores.t -= 15; scores.b -= 10; }
    else if (area === 'elbow') { scores.t -= 20; scores.b -= 5; }
    else if (area === 'hip') { scores.b -= 15; scores.t -= 10; }
  }
  function addAreaBonus(area) {
    if (area === 'knee') { scores.m += 15; scores.l += 10; }
    else if (area === 'shoulder') { scores.t += 15; scores.b += 10; }
    else if (area === 'elbow') { scores.t += 20; scores.b += 5; }
    else if (area === 'hip') { scores.b += 15; scores.t += 10; }
  }

  // ── Area selector (auto-advance) ──
  document.querySelectorAll('#ftciAreaGrid .ftci-area').forEach(function (el) {
    el.addEventListener('click', function () {
      // Remove old bonus if changing selection
      if (selectedArea) removeAreaBonus(selectedArea);
      selectedArea = el.getAttribute('data-area');
      document.querySelectorAll('#ftciAreaGrid .ftci-area').forEach(function (a) { a.classList.remove('selected'); });
      el.classList.add('selected');
      addAreaBonus(selectedArea);
      // Auto-advance after brief visual feedback
      setTimeout(function () { currentStep = 2; showStep(); }, 350);
    });
  });

  // ── Event listeners ──
  document.getElementById('ftciStartBtn').addEventListener('click', function () {
    currentStep = 1; showStep();
  });
  nextBtn.addEventListener('click', function () {
    // Only used for step 5 (slider) → go to email gate
    currentStep = 6;
    showStep();
  });
  backBtn.addEventListener('click', function () {
    currentStep = currentStep === 6 ? totalSteps : Math.max(1, currentStep - 1);
    showStep();
  });
  document.getElementById('ftciEmailBtn').addEventListener('click', submitEmail);

  // Slider Q5
  document.getElementById('ftciR5').addEventListener('input', function () { updateSlider(); });

  // Option cards Q2-Q4 (auto-advance)
  [2, 3, 4].forEach(function (q) {
    document.querySelectorAll('#ftciO' + q + ' .ftci-option').forEach(function (el) {
      el.addEventListener('click', function () {
        if (selectedOpts[q]) {
          scores.t -= parseInt(selectedOpts[q].getAttribute('data-t'));
          scores.l -= parseInt(selectedOpts[q].getAttribute('data-l'));
          scores.b -= parseInt(selectedOpts[q].getAttribute('data-b'));
          scores.m -= parseInt(selectedOpts[q].getAttribute('data-m'));
        }
        scores.t += parseInt(el.getAttribute('data-t'));
        scores.l += parseInt(el.getAttribute('data-l'));
        scores.b += parseInt(el.getAttribute('data-b'));
        scores.m += parseInt(el.getAttribute('data-m'));
        selectedOpts[q] = el;
        el.parentElement.querySelectorAll('.ftci-option').forEach(function (s) { s.classList.remove('selected'); });
        el.classList.add('selected');
        // Auto-advance after brief visual feedback
        setTimeout(function () {
          currentStep = q < 4 ? q + 1 : q + 1; // Q4 → Q5
          showStep();
        }, 350);
      });
    });
  });

  // ── Functions ──
  function updateSlider() {
    severityVal = parseInt(document.getElementById('ftciR5').value);
    var valEl = document.getElementById('ftciV5');
    if (severityVal < 25) valEl.textContent = 'Minimalus poveikis';
    else if (severityVal < 50) valEl.textContent = 'Šiek tiek riboja';
    else if (severityVal === 50) valEl.textContent = 'Vidutiniškai riboja';
    else if (severityVal < 75) valEl.textContent = 'Stipriai riboja';
    else valEl.textContent = 'Visiškai riboja';
  }

  function getResult() {
    var ft = scores.t; var fl = scores.l; var fb = scores.b; var fm = scores.m;
    // Knee area: meniscus not possible for shoulder/elbow/hip
    if (selectedArea !== 'knee') fm = 0;
    if (ft >= fl && ft >= fb && ft >= fm) return 'tendon';
    if (fl >= ft && fl >= fb && fl >= fm) return 'ligament';
    if (fb >= ft && fb >= fl && fb >= fm) return 'bursa';
    return 'meniscus';
  }

  function getSeverity() {
    if (severityVal < 30) return 'lengvas';
    if (severityVal < 65) return 'vidutinis';
    return 'sunkus';
  }

  var areaNames = { shoulder: 'peties', knee: 'kelio', elbow: 'alkūnės', hip: 'klubo' };

  function submitEmail() {
    var emailInput = document.getElementById('ftciEmailInput');
    var email = emailInput.value.trim();
    var errorEl = document.getElementById('ftciEmailError');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      errorEl.style.display = 'block'; emailInput.style.borderColor = '#e05555'; return;
    }
    errorEl.style.display = 'none'; emailInput.style.borderColor = '#00BEC3';
    sendToKlaviyo(email);
    currentStep = 7; showStep(); computeResults();
  }

  function sendToKlaviyo(email) {
    if (!KLAVIYO_COMPANY_ID || !KLAVIYO_LIST_ID) return;
    var resultType = getResult();
    var subData = {
      data: { type: 'subscription', attributes: { custom_source: 'Injury Type Widget',
        profile: { data: { type: 'profile', attributes: { email: email },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(subData)
    }).then(function (r) { console.log('[FTC Injury] subscribe:', r.status); }).catch(function (e) { console.error('[FTC Injury]', e); });
var subData2={data:{type:'subscription',attributes:{custom_source:'Injury Type Widget',profile:{data:{type:'profile',attributes:{email:email},subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}},relationships:{list:{data:{type:'list',id:'VfJCJm'}}}}}};
fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_COMPANY_ID,{method:'POST',headers:{'Content-Type':'application/json','revision':'2024-10-15'},body:JSON.stringify(subData2)});
resultType = {tendon:'Sausgyslės pažeidimas',ligament:'Raiščio pažeidimas',bursa:'Bursitas',meniscus:'Menisko pažeidimas'}[resultType] || resultType;
    var profileData = {
      data: { type: 'profile', attributes: { email: email, properties: {
        injury_type_result: resultType, injury_area: selectedArea || 'unknown',
        injury_severity: getSeverity(), injury_type_date: new Date().toISOString()
      } } }
    };
    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_COMPANY_ID, {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify(profileData)
    }).then(function (r) { console.log('[FTC Injury] profile:', r.status); }).catch(function (e) { console.error('[FTC Injury]', e); });
  }

  function computeResults() {
    var result = getResult();
    var severity = getSeverity();
    var area = areaNames[selectedArea] || '';
    var circle = document.getElementById('ftciResultCircle');
    var typeEl = document.getElementById('ftciResultType');
    var labelEl = document.getElementById('ftciResultLabel');
    var textEl = document.getElementById('ftciResultText');
    var dTitle = document.getElementById('ftciDetailTitle');
    var dText = document.getElementById('ftciDetailText');
    circle.className = 'ftci-result-circle';

    if (result === 'tendon') {
      circle.classList.add('tendon');
      typeEl.textContent = 'Tikėtina';
      labelEl.textContent = 'Sausgyslės pažeidimas';
      textEl.textContent = 'Jūsų simptomai rodo, kad labiausiai tikėtinas ' + area + ' srities sausgyslės pažeidimas (tendinopatija). Sunkumo laipsnis: ' + severity + '.';
      dTitle.textContent = 'Kas yra tendinopatija?';
      dText.textContent = 'Sausgyslės pažeidimas dažniausiai atsirandantis dėl pasikartojančios perkrovos ar netaisyklingos judesių technikos. Gera žinia — kineziterapija ir išcentrininiai pratimai yra vienas efektyviausių gydymo būdų. Svarbu pradėti reabilitaciją laiku, kad pažeidimas nepereitų į lėtinę stadiją.';
    } else if (result === 'ligament') {
      circle.classList.add('ligament');
      typeEl.textContent = 'Tikėtina';
      labelEl.textContent = 'Raiščio pažeidimas';
      textEl.textContent = 'Jūsų simptomai rodo, kad labiausiai tikėtinas ' + area + ' srities raiščio patempimas ar plyšimas. Sunkumo laipsnis: ' + severity + '.';
      dTitle.textContent = 'Kas yra raiščio pažeidimas?';
      dText.textContent = 'Raiščiai stabilizuoja sąnarius, todėl jų pažeidimas sukelia nestabilumo jausmą. Priklausomai nuo sunkumo, gydymas gali apimti nuo konservatyvios kineziterapijos iki chirurginio atkūrimo. Funkcinis įvertinimas padės nustatyti pažeidimo laipsnį ir parinkti tinkamą gydymo planą.';
    } else if (result === 'bursa') {
      circle.classList.add('bursa');
      typeEl.textContent = 'Tikėtina';
      labelEl.textContent = 'Bursitas';
      textEl.textContent = 'Jūsų simptomai rodo, kad labiausiai tikėtinas ' + area + ' srities bursitas — gleivinio maišelio uždegimas. Sunkumo laipsnis: ' + severity + '.';
      dTitle.textContent = 'Kas yra bursitas?';
      dText.textContent = 'Bursitas — tai gleivinio maišelio (bursos) uždegimas, kuris dažniausiai pasireiškia patinimu ir skausmu paspaudus. Gera žinia — bursitas paprastai gerai reaguoja į poilsį, šalčio terapiją ir kineziterapiją. Specialistas padės nustatyti priežastį ir užkirsti kelią pasikartojimui.';
    } else {
      circle.classList.add('meniscus');
      typeEl.textContent = 'Tikėtina';
      labelEl.textContent = 'Menisko pažeidimas';
      textEl.textContent = 'Jūsų simptomai rodo, kad tikėtinas kelio menisko pažeidimas — kremzlinio įdėklo plyšimas ar susidėvėjimas. Sunkumo laipsnis: ' + severity + '.';
      dTitle.textContent = 'Kas yra menisko pažeidimas?';
      dText.textContent = 'Meniskas — tai kelio sąnario kremzlinis įdėklas, kuris amortizuoja ir stabilizuoja sąnarį. Jo pažeidimas dažnai pasireiškia judesio blokavimu, spragtelėjimu ir patinimu. Daugelis menisko pažeidimų gydomi konservatyviai kineziterapijos pagalba, tačiau būtinas tikslus įvertinimas.';
    }
  }

  function showStep() {
    var slides = document.querySelectorAll('#ftciChecker .ftci-slide');
    slides.forEach(function (s) { s.classList.remove('active'); });

    if (currentStep === 0) {
      document.getElementById('ftciIntro').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    } else if (currentStep >= 1 && currentStep <= totalSteps) {
      document.getElementById('ftciQ' + currentStep).classList.add('active');
      progressWrap.style.display = 'block';
      progressFill.style.width = Math.round((currentStep / totalSteps) * 100) + '%';
      stepCount.textContent = currentStep + ' iš ' + totalSteps + ' klausimų';
      // Steps 1-4: auto-advance on click, hide Next; Step 5 (slider): show Next
      if (currentStep <= 4) {
        nav.style.display = currentStep === 1 ? 'none' : 'flex';
        nextBtn.style.display = 'none';
        backBtn.style.visibility = 'visible';
      } else {
        nav.style.display = 'flex';
        nextBtn.style.display = '';
        backBtn.style.visibility = 'visible';
        nextBtn.innerHTML = 'Gauti rezultatus ' + svgCheck;
        updateSlider();
      }
    } else if (currentStep === 6) {
      document.getElementById('ftciEmail').classList.add('active');
      nav.style.display = 'flex'; progressWrap.style.display = 'block';
      progressFill.style.width = '100%';
      stepCount.textContent = 'Paskutinis žingsnis';
      backBtn.style.visibility = 'visible'; nextBtn.style.display = 'none';
    } else if (currentStep === 7) {
      document.getElementById('ftciResults').classList.add('active');
      nav.style.display = 'none'; progressWrap.style.display = 'none';
    }
  }

})();